// removed by extract-text-webpack-plugin
module.exports = {"wrapper-link-url__options":"magazines_1Ijdt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LinkUrl/styles.scss
// module id = 1121
// module chunks = 1